// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-t {\n  background: rgb(253, 249, 238);\n  background: radial-gradient(circle, rgb(253, 249, 238) 70%, rgb(252, 228, 200) 100%);\n}\n.background-fit {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
